<template>
  <a
    :href="link ? link : null"
    :target="(link && link.startsWith('http')) ? '_blank' : ''"
    class="nq-link with-arrow learn-more">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10">
      <path d="M12.71,4.29l-4-4A1,1,0,1,0,7.29,1.71L9.59,4H1A1,1,0,0,0,1,6H9.59L7.29,8.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l4-4A1,1,0,0,0,12.71,4.29Z"/>
    </svg>
    {{ text ? text : "Learn more" }}
  </a>
</template>

<script>
export default {
  props: ['text', 'link'],
};
</script>

<style lang="stylus" scoped>
@import "../style/colors"

a.nq-link.with-arrow
  color highlight-blue
  font-weight bold
  text-decoration none
  display inline-block
  margin-right auto
  transition color 0.1s

  svg
    fill highlight-blue
    width .65em
    height .55em
    float right
    margin-left .4em
    margin-top .43em
    transition transform 0.4s
  &:hover
    color rgba(highlight-blue, 0.9)
    text-decoration none

    svg
      fill rgba(highlight-blue, 0.9)
      transform translate3D(1px, 0px, 0px)

</style>
